import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './BrandOnboardingInvoicePanel.scss';

import { startBrandSubscription, clearOnboardingObjects } from '../../../Actions/OnboardingActions';
import { syncCurrentUser } from '../../../Actions/UserActions';
import { getProfileFromObject } from '../../../Helpers/user_helpers';
import { isValidEmail } from '../../../Helpers/formatting';

import BrandOnboardingProgressBar from '../BrandOnboardingProgressBar';

const BrandOnboardingInvoicePanel = props => {
  const { user } = props;
  const history = useHistory();

  const [invoiceEmail, setInvoiceEmail] = useState(getProfileFromObject(user)?.email || '');

  const onNextClick = async () => {
    if (props.isLoading) return;
    else if (!isValidEmail(invoiceEmail)) return window.ALERT.error('Please enter a valid email address.');

    props.setIsLoading(true);
    const response = await props.startBrandSubscription(invoiceEmail);
    props.setIsLoading(false);
    if (!response.success) return window.ALERT.error('An error occurred while sending the invoice. Please try again.');

    window.ALERT.success('Invoice sent successfully!');
    await props.syncCurrentUser();
    await props.clearOnboardingObjects();
    history.push('/links');
  };

  return (
    <div className='brand-onboarding-invoice-panel-outer'>
      <div className='brand-onboarding-invoice-panel-inner'>
        <div className='brand-onboarding-split-container-outer'>
          <div className='brand-onboarding-split-container-inner'>
            <div className='brand-onboarding-graphic-container-outer'>
              <div className='brand-onboarding-graphic-container-inner'>
                <div className='brand-onboarding-graphic-container-stat'>
                  <div className='brand-onboarding-graphic-container-stat-label'>Our Numbers</div>
                  <div className='brand-onboarding-graphic-container-stat-number'>{props.featuredStat.number}+</div>
                  <div className='brand-onboarding-graphic-container-stat-description'>{props.featuredStat.description}</div>
                </div>

                <BrandOnboardingProgressBar
                  goToPanel={props.goToPanel}
                  sections={props.sections}
                  activeSectionName={props.activeSectionName}
                  activePanelName={props.activePanelName}
                />
              </div>

              <div className='brand-onboarding-graphic-background'>
                <img className='brand-onboarding-graphic-background-image' src={props.backgroundImage} alt='name panel graphic' />
                <div className='brand-onboarding-graphic-background-overlay'></div>
              </div>
            </div>

            <div className='brand-onboarding-input-container-outer'>
              <div className='brand-onboarding-input-container-number-marker'>{props.panelNumber}</div>

              <div className={cn('brand-onboarding-input-container-inner', { isLoading: props.isLoading })}>
                <div className='brand-onboarding-title-text'>Welcome, to ShopMy!</div>
                <div className='brand-onboarding-subtitle-text'>By clicking below we will send you an invoice for your package.</div>

                <div className='brand-onboarding-input-label'>Email to send invoice to</div>
                <div className='brand-onboarding-input-sublabel'>
                  This email will be the direct contact for ShopMy initial invoice for subscription
                </div>
                <input
                  className='brand-onboarding-input'
                  type='text'
                  placeholder='Enter Email'
                  onChange={e => setInvoiceEmail(e.target.value)}
                  value={invoiceEmail}
                />

                <div className='brand-onboarding-pagination-buttons'>
                  <button className='brand-onboarding-button stretch' onClick={() => props.goToPreviousPanel()}>
                    Back
                  </button>
                  <button className='brand-onboarding-button stretch primary' onClick={onNextClick}>
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

BrandOnboardingInvoicePanel.propTypes = {
  onboarding: PropTypes.object.isRequired,
  startBrandSubscription: PropTypes.func.isRequired,

  panels: PropTypes.array.isRequired,
  goToPreviousPanel: PropTypes.func.isRequired,
  goToNextPanel: PropTypes.func.isRequired,
  goToPanel: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const { onboarding, user } = state;
  return { onboarding, user };
};

export default connect(mapStateToProps, {
  startBrandSubscription,
  syncCurrentUser,
  clearOnboardingObjects
})(withRouter(BrandOnboardingInvoicePanel));
